import { useQuery } from '@tanstack/react-query';

import {
  campaignsService,
  FetchCampaignsRequest,
  FetchCampaignsResponse,
} from '@aslanpay/portal-common-lib';

const useFetchCampaigns = (params: FetchCampaignsRequest) => {
  return useQuery<FetchCampaignsResponse, Error>(
    ['fetchCampaigns', params],
    () => campaignsService.fetchCampaigns(params),
    {
      enabled: !!params.companyId,
    }
  );
};

export default useFetchCampaigns;
